// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-user-page {
  /* Customize the label (the container-checkbox) */
  /* Hide the browser's default checkbox */
  /* Create a custom checkbox */
  /* On mouse-over, add a grey background color */
  /* When the checkbox is checked, add a blue background */
  /* Create the checkmark/indicator (hidden when not checked) */
  /* Show the checkmark when checked */
  /* Style the checkmark/indicator */
}
.task-user-page > * {
  display: flex;
  align-items: start;
  padding: 1rem;
}
.task-user-page .tasks-list {
  width: 100%;
  border: none;
}
.task-user-page .link-tasks {
  margin: 1rem;
  padding: 1rem;
}
.task-user-page .btn-valid {
  width: 100%;
}
.task-user-page .btn-valid > * {
  margin: 1rem;
  width: 100%;
}
.task-user-page .container-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.task-user-page .container-checkbox .text {
  height: 25px;
}
.task-user-page .container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.task-user-page .checkmark {
  position: absolute;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}
.task-user-page .container-checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}
.task-user-page .container-checkbox input:checked ~ .checkmark {
  background-color: #2196F3;
}
.task-user-page .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.task-user-page .container-checkbox input:checked ~ .checkmark:after {
  display: block;
}
.task-user-page .container-checkbox .checkmark:after {
  left: 10px;
  top: 5px;
  width: 5px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}`, "",{"version":3,"sources":["webpack://./src/presentation/pages/TasksUser/TaskUserPage.scss"],"names":[],"mappings":"AAAA;EA0BI,iDAAA;EAiBA,wCAAA;EASA,6BAAA;EASA,+CAAA;EAKA,wDAAA;EAKA,6DAAA;EAOA,oCAAA;EAKA,kCAAA;AA1EJ;AAPI;EACI,aAAA;EACA,kBAAA;EACA,aAAA;AASR;AANI;EACI,WAAA;EACA,YAAA;AAQR;AALI;EACI,YAAA;EACA,aAAA;AAOR;AAJI;EAKI,WAAA;AAER;AANQ;EACI,YAAA;EACA,WAAA;AAQZ;AAFI;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAIR;AAFQ;EACI,YAAA;AAIZ;AACI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AACR;AAGI;EACI,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AADR;AAKI;EACI,sBAAA;AAHR;AAOI;EACI,yBAAA;AALR;AASI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AAPR;AAWI;EACI,cAAA;AATR;AAaI;EACI,UAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;AAXR","sourcesContent":[".task-user-page {\n\n    & > * {\n        display: flex;\n        align-items: start;\n        padding: 1rem;\n    }\n\n    .tasks-list {\n        width: 100%;\n        border: none;\n    }\n\n    .link-tasks {\n        margin: 1rem;\n        padding: 1rem;\n    }\n\n    .btn-valid {\n        & > * {\n            margin: 1rem;\n            width: 100%;\n        }\n        width: 100%;\n    }\n\n    /* Customize the label (the container-checkbox) */\n    .container-checkbox {\n        display: block;\n        position: relative;\n        padding-left: 35px;\n        cursor: pointer;\n        font-size: 22px;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n\n        .text {\n            height: 25px;\n        }\n    }\n  \n    /* Hide the browser's default checkbox */\n    .container-checkbox input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n    }\n    \n    /* Create a custom checkbox */\n    .checkmark {\n        position: absolute;\n        left: 0;\n        height: 25px;\n        width: 25px;\n        background-color: #eee;\n    }\n    \n    /* On mouse-over, add a grey background color */\n    .container-checkbox:hover input ~ .checkmark {\n        background-color: #ccc;\n    }\n    \n    /* When the checkbox is checked, add a blue background */\n    .container-checkbox input:checked ~ .checkmark {\n        background-color: #2196F3;\n    }\n    \n    /* Create the checkmark/indicator (hidden when not checked) */\n    .checkmark:after {\n        content: \"\";\n        position: absolute;\n        display: none;\n    }\n    \n    /* Show the checkmark when checked */\n    .container-checkbox input:checked ~ .checkmark:after {\n        display: block;\n    }\n    \n    /* Style the checkmark/indicator */\n    .container-checkbox .checkmark:after {\n        left: 10px;\n        top: 5px;\n        width: 5px;\n        height: 15px;\n        border: solid white;\n        border-width: 0 3px 3px 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n    }\n   \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
